import { RegisterUserCompleteCommand } from '@/app/proxy/proxies';
import { SharedModule } from '@/app/shared/shared.module';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { RegisterationSteps } from '@/app/auth/shared/auth-enums';
import { registrationProgress } from '@/app/auth/shared/registration-progress';
import { AuthService } from '@/app/auth/shared/services/auth.service';

@Component({
  selector: 'auth-register-about',
  imports: [SharedModule],
  templateUrl: './about.component.html',
  styleUrl: './about.component.less',
})
export class AboutComponent implements OnInit {
  @Output() steperChange = new EventEmitter<RegisterationSteps>();

  registerModal: RegisterUserCompleteCommand = new RegisterUserCompleteCommand();

  constructor(private _authService: AuthService) {}

  ngOnInit(): void {
    const registerModal = this._authService.getRegisterModal();
    if (registerModal !== undefined) {
      this.registerModal = registerModal;
    } else {
      this.steperChange.emit(RegisterationSteps.PHONE);
    }
  }

  get progressValues(): number[] {
    return registrationProgress(RegisterationSteps.ABOUT, this._authService.getPhoneOtpRequired());
  }

  /**
   * Name and surname are kept on the register modal. The account is created
   * only after the profession step, once that choice has been stored.
   */
  continueAboutStep() {
    if (this.registerModal == undefined) {
      return;
    }

    this._authService.setRegisterModal(this.registerModal);
    this.steperChange.emit(RegisterationSteps.PROFESSION);
  }

  backButton() {
    const phoneOtpRequired = this._authService.getPhoneOtpRequired();
    if (phoneOtpRequired === true) {
      this.steperChange.emit(RegisterationSteps.PASSWORD);
      return;
    }

    if (phoneOtpRequired === false) {
      // emailOtp 0 is the API's "code not required" value, so there is no code screen to reopen.
      this.steperChange.emit(
        this.registerModal?.emailOtp === 0 ? RegisterationSteps.EMAIL : RegisterationSteps.VERIFY_EMAIL_OTP
      );
      return;
    }

    this.steperChange.emit(RegisterationSteps.PHONE);
  }
}
